export default __webpack_public_path__ + "static/media/project-3.cb18ce69.jpg";